import request from '@/utils/request';
/**获取列表数据 */
export function claimsTypeList(data) {
  return request.post('admin/claims-sort/list', data);
}
export function addClaimsType(data) {
  return request.post('admin/claims-sort/store', data);
}
export function editClaimsType(data) {
  return request.post('admin/claims-sort/edit', data);
}
export function claimsTypeStatus(data) {
  return request.post('admin/claims-sort/status', data);
}
export function delClaimsType(data) {
  return request.post('admin/claims-sort/delete', data);
}
export function claimsResource(data) {
  return request.post('admin/claims-sort/resource', data);
}